import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../../css/checkoutHeader.scss";
import { generateDonationUrl } from "../../utils/urlUtils";

const CheckoutHeader = () => {
  const location = useLocation();
  const detailsData = location.state?.detailsData || null;
  const returnTo =
    detailsData ? generateDonationUrl(detailsData) : "/";
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="checkout-header">
      <div className="checkout-header__nav">
        <div className="checkout-header__nav_inner">
          <div className="checkout-header__nav_inner_return">
            <Link to={returnTo}>
              <svg
                t="1763633148216"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2746"
                width="200"
                height="200"
              >
                <path
                  d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z"
                  p-id="2747"
                ></path>
              </svg>
              <span>Fundraiser</span>
            </Link>
          </div>
          <Link to={returnTo} className="checkout-header__logo" onClick={toTop}>
            <img alt="" src={process.env.PUBLIC_URL + "/head/ico-new.png"} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default CheckoutHeader;
